import Modal from "../../Modal"

interface ErrorModalProps {
	message: string,
}

const ErrorModal = (props: ErrorModalProps) => {
	return (
		<Modal title="Oops, something went wrong!">
			<p>{props.message}</p>

			<button className="rgModalButton primary" onClick={() => window.location.reload}>Reload</button>
		</Modal>
	)
}

export default ErrorModal;
